module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.svg?f154cf4caff1dfef6e756f33606827cd";